import { render, staticRenderFns } from "./ClaimsGrid.vue?vue&type=template&id=7121adb1&"
import script from "./ClaimsGrid.vue?vue&type=script&lang=js&"
export * from "./ClaimsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsGrid.vue?vue&type=style&index=0&id=7121adb1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports